import React, {Component} from 'react';

import '../../Frontpage.css';

import '../../common_styles/table.css'

export default class ApiDocs extends Component {

    constructor(props) {
        super(props);

        this.state = {
            accessToken: this.props.accessToken,
        };
    }

    render() {
        return (
            <div>
                <div style={{
                    float: "left",
                    padding: 10,
                    margin: 25,
                    backgroundColor: "white",
                    border: "1px solid lightgrey",
                    display: "inline-block",
                    width: 1200
                }}>
                    <div style={{width: "100%", height: 40, borderBottom: "1px solid black", fontSize: 20}}>Api Keys
                    </div>
                    <header>
                        <br/>
                        <br/>
                        <h3>General API information</h3>
                        <span>
                            Base url: https://api.arboreal.se <br/><br/>
                            <table>
                            <tr>
                                <th>Header fields: </th>
                                <th>Header name</th>
                                <th>Header value</th>
                            </tr>
                            <tr>
                                <td></td>
                                <td>Content-Type</td>
                                <td>application/json</td>
                            </tr>
                            <tr>
                                <td></td>
                                <td>Authorization:</td>
                                <td>Key [API KEY]</td>
                            </tr>
                            </table>
                        </span>
                        <h3>API endpoints</h3>
                        Here follows all available API endpoints reachable with an company API key. <br/>
                        <h4>User management</h4>
                        <span>
                            <table>
                            <tr>
                                <th>Get Company Users</th>
                                <th></th>
                            </tr>
                            <tr>
                                <td>Path:</td>
                                <td>/getCompanyCustomers</td>
                            </tr>
                            <tr>
                                <td>Type:</td>
                                <td>GET</td>
                            </tr>
                            <tr>
                                <td>query params:</td>
                                <td>none</td>
                            </tr>
                            </table>
                            <br/><br/>
                            <table>
                            <tr>
                                <th>Delete Customer From Company</th>
                                <th></th>
                            </tr>
                            <tr>
                                <td>Path:</td>
                                <td>/deleteCustomerFromCompany</td>
                            </tr>
                            <tr>
                                <td>Type:</td>
                                <td>DELETE</td>
                            </tr>
                            <tr>
                                <td>Body:</td>
                                <td>
                                    <table>
                                        <tr>
                                            <td>id</td>
                                            <td>[int: id of user]</td>
                                        </tr>
                                    </table>
                                </td>
                            </tr>
                            </table>
                            <br/>
                            <br/>
                              <table>
                            <tr>
                                <th>Get Company Whitelist</th>
                                <th></th>
                            </tr>
                            <tr>
                                <td>Path:</td>
                                <td>/getCompanyWhitelist</td>
                            </tr>
                            <tr>
                                <td>Type:</td>
                                <td>GET</td>
                            </tr>
                            <tr>
                                <td>query params:</td>
                                <td>none</td>
                            </tr>
                            </table>
                            <br/>
                            <br/>

                            <table>
                            <tr>
                                <th>Add to Company Whitelest</th>
                                <th></th>
                            </tr>
                            <tr>
                                <td>Path:</td>
                                <td>/addToCompanyWhitelist</td>
                            </tr>
                            <tr>
                                <td>Type:</td>
                                <td>POST</td>
                            </tr>
                            <tr>
                                <td>Body:</td>
                                <td>
                                    <table>
                                        <tr>
                                            <td>email</td>
                                            <td>[string: email]</td>
                                        </tr>
                                    </table>
                                </td>
                            </tr>
                            </table>
                        </span>
                        <h4>API Key</h4>
                        <span>
                        <table>
                            <tr>
                                <th>Generate API Key</th>
                                <th></th>
                            </tr>
                            <tr>
                                <td>Path:</td>
                                <td>/generateApiKey</td>
                            </tr>
                            <tr>
                                <td>Type:</td>
                                <td>POST</td>
                            </tr>
                            <tr>
                                <td>Body:</td>
                                <td>
                                    none
                                </td>
                            </tr>
                        </table>
                        <br/>
                        <br/>
                        <table>
                            <tr>
                                <th>Get Company Keys</th>
                                <th></th>
                            </tr>
                            <tr>
                                <td>Path:</td>
                                <td>/getCompanyKeys</td>
                            </tr>
                            <tr>
                                <td>Type:</td>
                                <td>GET</td>
                            </tr>
                            <tr>
                                <td>query params:</td>
                                <td>none</td>
                            </tr>
                        </table>
                            <br/>
                            <br/>
                        <table>
                            <tr>
                                <th>Delete API Key</th>
                                <th></th>
                            </tr>
                            <tr>
                                <td>Path:</td>
                                <td>/deleteCompanyKey</td>
                            </tr>
                            <tr>
                                <td>Type:</td>
                                <td>DELETE</td>
                            </tr>
                            <tr>
                                <td>Body:</td>
                                <td>
                                    <table>
                                        <tr>
                                            <td>id</td>
                                            <td>[int : id of key]</td>
                                        </tr>
                                    </table>
                                </td>
                            </tr>
                        </table>
                        </span>
                        <h4>Samples</h4>
                        <span>
                        <table>
                            <tr>
                                <th>Get Filtered samples</th>
                                <th></th>
                            </tr>
                            <tr>
                                <td>Path:</td>
                                <td>/getFilteredSamples</td>
                            </tr>
                            <tr>
                                <td>Type:</td>
                                <td>GET</td>
                            </tr>
                            <tr>
                                <td>Parameters:</td>
                                <td>
                                    <table>
                                        <tr>
                                            <td>Optional</td>
                                            <td>emails</td>
                                            <td>[string array : array of emails]</td>
                                        </tr>
                                        <tr>
                                            <td>Optional</td>
                                            <td>from</td>
                                            <td>[date : samples after date, format: YYYY-MM-DD]</td>
                                        </tr>
                                        <tr>
                                            <td>Optional</td>
                                            <td>to</td>
                                            <td>[date : samples before date, format: YYYY-MM-DD]</td>
                                        </tr>
                                    </table>
                                </td>
                            </tr>
                        </table>
                        <br/>
                        <br/>
                            <table>
                            <tr>
                                <th>Get Detailed Sample</th>
                                <th></th>
                            </tr>
                            <tr>
                                <td>Path:</td>
                                <td>/getSampleById</td>
                            </tr>
                            <tr>
                                <td>Type:</td>
                                <td>GET</td>
                            </tr>
                            <tr>
                                <td>Parameters:</td>
                                <td>
                                    <table>
                                        <tr>
                                            <td>Required</td>
                                            <td>id</td>
                                            <td>[int id : id of the sample]</td>
                                        </tr>
                                    </table>
                                </td>
                            </tr>
                        </table>
                        <br/>
                        <br/>
                        <table>
                            <tr>
                                <th>Get Height Age Growth</th>
                                <th></th>
                            </tr>
                            <tr>
                                <td>Path:</td>
                                <td>/getHeightAgeGrowthBySampleId</td>
                            </tr>
                            <tr>
                                <td>Type:</td>
                                <td>GET</td>
                            </tr>
                            <tr>
                                <td>Parameters:</td>
                                <td>
                                    <table>
                                        <tr>
                                            <td>Required</td>
                                            <td>sampleId</td>
                                            <td>[int sampleId : id of the sample]</td>
                                        </tr>
                                    </table>
                                </td>
                            </tr>
                        </table>
                        </span>

                    </header>
                </div>
            </div>
        );
    }
}
